export const ID_PROOF = 'ID_PROOF';
export const ADDRESS_PROOF = 'ADDRESS_PROOF';
